import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const ClockHistoryIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="solid/clock-history"><path id="Vector (Stroke)" d="M19.0996 12C19.0996 8.3638 16.1186 5.40039 12.4209 5.40039C10.4396 5.40039 8.66265 6.25125 7.43945 7.60352C7.235 7.82957 7.04659 8.07017 6.875 8.32227L7.64258 8.19531C8.13293 8.11415 8.59654 8.44616 8.67773 8.93652C8.75878 9.42681 8.42682 9.8905 7.93652 9.97168L5.41992 10.3877C5.09148 10.442 4.75969 10.3105 4.55761 10.0459L3.28515 8.37988C2.98343 7.98488 3.05909 7.41988 3.4541 7.11816C3.84905 6.81669 4.41316 6.89229 4.71484 7.28711L5.08984 7.77832C5.38099 7.28307 5.7213 6.82015 6.10449 6.39648C7.65685 4.68018 9.91299 3.59961 12.4209 3.59961C17.0948 3.59961 20.9004 7.35193 20.9004 12C20.9004 16.6481 17.0948 20.4004 12.4209 20.4004C8.81885 20.4004 5.73739 18.1739 4.50976 15.0283C4.32909 14.5654 4.55766 14.0431 5.0205 13.8623C5.48355 13.6816 6.00581 13.911 6.18652 14.374C7.15022 16.8433 9.57589 18.5996 12.4209 18.5996C16.1186 18.5996 19.0996 15.6362 19.0996 12ZM11.7002 7.7998C11.7003 7.30297 12.1028 6.9006 12.5996 6.90039C13.0966 6.90039 13.4999 7.30284 13.5 7.7998V12.2998H16C16.4971 12.2998 16.9004 12.7031 16.9004 13.2002C16.9003 13.6972 16.497 14.0996 16 14.0996H12.5996C12.1028 14.0994 11.7003 13.697 11.7002 13.2002V7.7998Z" fill="currentColor" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default ClockHistoryIcon;